import { ChevronRight as IconChevronRight } from "@mui/icons-material";
import { Button, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
    onApprove?: () => Promise<void>;
    loading?: boolean;
    isEverythingReady: boolean;
};

export function ProjectReviewVisitV2ApprovalButton({ onApprove, loading = false, isEverythingReady }: Props) {
    const { t } = useTranslation("project");

    return (
        <Stack
            component={Paper}
            justifyContent="space-between"
            rowGap={1}
            sx={theme => ({
                padding: 2,
                backgroundColor: isEverythingReady ? theme.palette.primary.dark : theme.palette.background.default,
            })}
        >
            {!isEverythingReady && (
                <Typography variant="caption" color="textSecondary">
                    {t("projectReviewVisitV2.overview.finalisePending")}
                </Typography>
            )}
            <Button
                disabled={!isEverythingReady || loading}
                variant="contained"
                onClick={onApprove}
                endIcon={<IconChevronRight />}
                fullWidth
            >
                {t("projectReviewVisitV2.overview.finaliseButton")}
            </Button>
        </Stack>
    );
}
